// Nomenclatura para eventos
// [SUBMODULE]_[TYPE]_[DESCRIPTION]_[ACTION]

const moduleName = "QUEUES";

export const QueuesEvent = {
  QUEUE_MODAL_ADD_OPENED: `${moduleName}-QUEUES_MODAL_ADD_OPENED`,
  QUEUE_MODAL_EDIT_OPENED: `${moduleName}-QUEUES_MODAL_EDIT_OPENED`,
};
